import CreateRfq from '../../../../../../client/src/rfq/src/viewmodel/CreateRfqViewModel';
import { DesBaseCollabAcc } from '../utils/des-base-collab-acc';

export default class DesCreateRfq extends DesBaseCollabAcc {

    constructor() {
        super(CreateRfq);
    }

    get collaborationspaceid() {
        return this.getAttribute('collaborationspaceid') || this.getAttribute('collaborationspace-id');
    }

    get parentprojectid() {
        return this.getAttribute('parentprojectid') || this.getAttribute('parent-project-id');
    }

    get disabletags() {
        return this.getAttribute('disabletags') || this.getAttribute('disable-tags');
    }

    getProps() {
        return {
            collaborationspaceid: this.collaborationspaceid,
            parentprojectid: this.parentprojectid,
            disabletags: this.disabletags
        };
    }

    static get observedAttributes() {
        return [ ...DesBaseCollabAcc.observedAttributes, 'collaborationspaceid', 'collaborationspace-id',
    'disabletags', 'disable-tags', 'parentprojectid', 'parent-project-id' ];
    }
}

if (!window.customElements.get('des-create-rfq')) {
    window.customElements.define('des-create-rfq', DesCreateRfq);
}
